import 'shared/api/session';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'app/App';
import reportWebVitals from 'app/bootstrap/reportWebVitals';
import 'app/theme/global.css';
import { canonicalAppUrl } from 'shared/config';

export const bootstrapApplication = (): void => {
    const canonical = canonicalAppUrl();
    if (canonical) {
        window.location.replace(canonical);
        return;
    }
    const container = document.getElementById('root');
    if (!container) {
        throw new Error('Unity could not start because the root container is missing.');
    }

    ReactDOM.createRoot(container).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );

    reportWebVitals();
};
